export default __webpack_public_path__ + "static/media/cl.71b8727f.svg";